
















import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { AdgroupFormData, BidStrategyType, DeepBidType } from '@tt4b/ttam-enums';
import TargetItem from '../target-item/index.vue';
import { useLabelTip } from '../hooks/unified-bid-strategy';
import { StrategyOption } from '../consts';

const name = 'ttam-bid-strategy-target-roas';
export default defineComponent({
  name,
  components: {
    TargetItem,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    strategyList: {
      type: Array as PropType<StrategyOption[]>,
      default: () => [],
    },
    allStrategyList: {
      type: Array as PropType<StrategyOption[]>,
      default: () => [],
    },
    isSupportHighestValue: {
      type: Boolean,
      default: false,
    },
    isSupportMinimumRoas: {
      type: Boolean,
      default: false,
    },
    requiredRules: {
      type: Array,
      default: () => [],
    },
    optionalRules: {
      type: Array,
      default: () => [],
    },
    disabledSwitch: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      adgroupData,
      disabledSwitch,
      strategyList,
      allStrategyList,
      isSupportHighestValue,
      isSupportMinimumRoas,
      requiredRules,
      optionalRules,
    } = toRefs(props);
    const getStrategy = (type: BidStrategyType) => allStrategyList.value.find(item => item.type === type);

    const isHighestValueSelected = computed(() => adgroupData.value.deepBidType === DeepBidType.VO_HIGHEST_VALUE);
    const disabledInput = computed(() => disabledSwitch.value && isHighestValueSelected.value);
    const strategyListSelectable = computed(() => {
      const supportList: StrategyOption[] = [];
      if (isSupportHighestValue.value) {
        supportList.push(getStrategy(BidStrategyType.HIGHEST_VALUE));
      }
      if (isSupportMinimumRoas.value) {
        supportList.push(getStrategy(BidStrategyType.MIN_ROAS));
      }

      if (!disabledSwitch.value) {
        return supportList;
      }
      return isHighestValueSelected.value
        ? supportList
        : supportList.filter(item => item.type === BidStrategyType.MIN_ROAS);
    });
    const optional = computed(() => strategyListSelectable.value.length > 1);
    const settableStrategy = computed(() =>
      isSupportMinimumRoas.value ? getStrategy(BidStrategyType.MIN_ROAS) : undefined,
    );
    const setFormKey = computed(() => settableStrategy.value?.dataKey);
    const _bid = computed({
      get: () => (adgroupData.value?.[setFormKey.value] === 0 ? '' : adgroupData.value?.[setFormKey.value]),
      set: val => {
        if (val === adgroupData.value?.[setFormKey.value]) {
          return;
        }
        emit('roas-change', {
          [setFormKey.value]: val || 0,
          deepBidType: val || !optional.value ? DeepBidType.VO_MIN_ROAS : DeepBidType.VO_HIGHEST_VALUE,
        });
      },
    });
    const currentStrategy = computed(() => {
      if (optional.value) {
        return _bid.value ? getStrategy(BidStrategyType.MIN_ROAS) : getStrategy(BidStrategyType.HIGHEST_VALUE);
      } else {
        return settableStrategy.value ? settableStrategy.value : getStrategy(BidStrategyType.HIGHEST_VALUE);
      }
    });
    const { labelTip } = useLabelTip({
      adgroupData,
      optional,
      settableStrategy,
    });

    const rules = computed(() => (optional.value ? optionalRules.value : requiredRules.value));

    return {
      name,
      optional,
      settableStrategy,
      currentStrategy,
      _bid,
      labelTip,
      setFormKey,
      rules,
      disabledInput,
    };
  },
});
